<template>
  <div class="select-constituents-layout">
    <a-form-model
      layout="inline"
      :model="searchForm"
      @submit="searchClasses"
      @submit.native.prevent
    >
      <a-form-model-item label="Search text">
        <a-input-search
          placeholder="Search..."
          v-model="searchForm.searchText"
          style="width: 180px;"
        />
      </a-form-model-item>
      <a-form-model-item label="Impact sector">
        <a-select
          default-value=""
          v-model="searchForm.sector"
          style="width: 180px;"
        >
          <a-select-option value="">
            All impact sectors
          </a-select-option>
          <a-select-option value="FoodAgriculture">
            Agriculture
          </a-select-option>
          <a-select-option value="ClimateEnergy">
            Climate and energy
          </a-select-option>
          <a-select-option value="Education">
            Education
          </a-select-option>
          <a-select-option value="Healthcare">
            Healthcare
          </a-select-option>
          <a-select-option value="HousingCommunity">
            Housing
          </a-select-option>
          <a-select-option value="Microfinance">
            Microfinance
          </a-select-option>
          <a-select-option value="MultiSector">
            Multi sector
          </a-select-option>
          <a-select-option value="SMEDevelopment">
            SME development
          </a-select-option>
          <a-select-option value="Other">
            Other
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Asset strategy">
        <a-select
          default-value=""
          v-model="searchForm.assetStrategy"
          style="width: 180px;"
        >
          <a-select-option value="">
            All asset strategies
          </a-select-option>
          <a-select-option value="FixedIncome">
            Fixed income
          </a-select-option>
          <a-select-option value="Equity">
            Equity
          </a-select-option>
          <a-select-option value="Mixed">
            Mixed
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Currency">
        <a-select default-value="USD" v-model="searchForm.currency">
          <a-select-option value="USD">
            USD
          </a-select-option>
          <a-select-option value="EUR">
            EUR
          </a-select-option>
          <a-select-option value="CHF">
            CHF
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Hedging strategy">
        <a-select
          default-value="all"
          v-model="searchForm.hedgingStrategy"
          style="width: 200px;"
        >
          <a-select-option value="">
            All funds
          </a-select-option>
          <a-select-option value="FullyHedged">
            Hedged funds
          </a-select-option>
          <a-select-option value="FullyUnHedged">
            Unhedged funds
          </a-select-option>
          <a-select-option value="PartiallyHedged">
            Partially hedged funds
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" icon="search">
          Search
        </a-button>
      </a-form-model-item>
    </a-form-model>

    <ul class="my-4 divide-y divide-gray-200 h-full overflow-y-auto">
      <li
        v-for="entry in foundClassesWithReports"
        :key="entry.class.key"
        class="p-5 cursor-pointer"
        :class="{
          'bg-yellow-100': entry.isSelected,
          'bg-white': !entry.isSelected,
        }"
        @click="toggleSelection(entry)"
      >
        <div class="flex">
          <div class="flex-1">
            {{ entry.fund.name }} - {{ entry.class.name }}
          </div>
          <div class="w-10">
            <font-awesome-icon
              v-show="entry.isSelected"
              icon="check-circle"
              class="ml-4 text-green-600 text-2xl"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    instrumentKeysFromReports: {
      query: gql`
        query {
          instrumentKeysFromReports
        }
      `,
    },
  },
  data() {
    return {
      searchForm: {
        searchText: '',
        sector: '',
        assetStrategy: '',
        currency: 'USD',
        hedgingStrategy: '',
      },
      foundClasses: [],
      instrumentKeysFromReports: [],
    }
  },
  computed: {
    foundClassesWithReports() {
      return this.foundClasses.filter((e) =>
        this.instrumentKeysFromReports.includes(e.class.key),
      )
    },
  },
  methods: {
    async searchClasses() {
      this.foundClasses = []
      const result = await this.$apollo.query({
        client: 'funds',
        query: gql`
          query SearchClasses($input: SearchClassesCriteriasInput) {
            searchClasses(input: $input) {
              entries {
                fund {
                  key
                  name
                }
                class {
                  key
                  name
                }
              }
            }
          }
        `,
        variables: {
          input: {
            searchText: this.searchForm.searchText,
            impactSector: this.searchForm.sector,
            assetStrategy: this.searchForm.assetStrategy,
            currency: this.searchForm.currency,
            hedgingStrategy: this.searchForm.hedgingStrategy,
          },
        },
      })
      this.foundClasses = result.data.searchClasses.entries
      this.$forceUpdate()
      this.$emit('selectionChanged', [])
    },
    toggleSelection(entry) {
      entry.isSelected = !entry.isSelected
      this.$forceUpdate()
      this.$emit(
        'selectionChanged',
        this.foundClasses.filter((c) => c.isSelected),
      )
    },
  },
}
</script>

<style scoped>
.select-constituents-layout {
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}
</style>
